export default [
  {
    "id": "mat-enem-0174",
    "numero": 1674,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "O diretor de um colégio leu numa revista que os \npés das mulheres estavam aumentando. Há \nalguns anos, a média do tamanho dos calçados \ndas mulheres era de 35,5 e, hoje, é de 37,0. \nEmbora não fosse uma informação científica, \nele ficou curioso e fez uma pesquisa com as \nfuncionárias do seu colégio, obtendo o quadro a \nseguir: \n \n \n \nEscolhendo uma funcionária ao acaso e saben-\ndo que ela tem calçado maior que 36,0, a pro-\nbabilidade de ela calçar 38,0 é: \n \nA) 1/3        \nB) 1/5        \nC) 2/5        \nD) 5/7         \nE) 5/14",
    "alternativas": {
      "C": "2/5",
      "D": "5/7",
      "A": "1/3",
      "B": "1/5"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 174,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0175",
    "numero": 1675,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "O quadro seguinte mostra o desempenho de um \ntime de futebol no último campeonato. A coluna \nda esquerda mostra o número de gols marcados \ne a coluna da direita informa em quantos jogos \no time marcou aquele número de gols. \n \n \nSe X, Y e Z são, respectivamente, a média, a \nmediana e a moda desta distribuição, então: \n \nA) X = Y < Z. \nB) Z < X = Y. \nC) Y < Z < X. \nD) Z < X < Y. \nE) Z < Y < X.",
    "alternativas": {
      "E": "Z < Y < X.",
      "B": "Z < X = Y.",
      "C": "Y < Z < X.",
      "D": "Z < X < Y."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 175,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0176",
    "numero": 1676,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A disparidade de volume entre os planetas é tão \ngrande que seria possível colocá-los uns dentro \ndos outros. O planeta Mercúrio é o menor de \ntodos. Marte é o segundo menor: dentro dele \ncabem três Mercúrios. Terra é o único com vida: \ndentro dela cabem sete Martes. Netuno é o \nquarto maior: dentro dele cabem 58 Terras. \nJúpiter é o maior dos planetas: dentro dele ca-\nbem 23 Netunos. \n \nSeguindo o raciocínio proposto, quantas Terras \ncabem dentro de Júpiter? \n \nA) 406        \nB) 1334        \nC) 4002          \nD) 9338         \nE) 28014",
    "alternativas": {
      "D": "9338",
      "E": "28014",
      "A": "406",
      "B": "1334"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 176,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0177",
    "numero": 1677,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Um dos grandes problemas da poluição dos \nmananciais (rios, córregos e outros) ocorre pelo \nhábito de jogar óleo utilizado em frituras nos \nencanamentos que estão interligados com o \nsistema de esgoto. Se isso ocorrer, cada 10 \nlitros de óleo poderão contaminar 10 milhões de \nlitros de água potável. \n \nSuponha que todas as famílias de uma cidade \ndescartem os óleos de frituras através dos en-\ncanamentos e consomem 1000 litros de óleo em \nfrituras por semana. Qual seria, em litros, a \nquantidade de água potável contaminada por \nsemana nessa cidade? \n \nA) 10-2 \nB) 103 \nC) 104 \nD) 106 \nE) 109",
    "alternativas": {
      "B": "103",
      "D": "106",
      "E": "109",
      "A": "10-2"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 177,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0178",
    "numero": 1678,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Um porta-lápis de madeira foi construído no \nformato cúbico, seguindo o modelo ilustrado a \nseguir. O cubo de dentro é vazio. A aresta do \ncubo maior mede 12 cm e a do cubo menor, que \né interno, mede 8 cm. \n \n \nO volume de madeira utilizado na confecção \ndesse objeto foi de: \n \nA) 12 cm3.        \nB) 64 cm3.              \nC) 96 cm3.          \nD) 1 216 cm3.              \nE) 1 728 cm3.",
    "alternativas": {
      "C": "96 cm3.",
      "D": "1 216 cm3.",
      "A": "12 cm3.",
      "B": "64 cm3."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 178,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0179",
    "numero": 1679,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Ronaldo é um garoto que adora brincar com \nnúmeros. Numa dessas brincadeiras, empilhou \ncaixas numeradas de acordo com a sequência \nconforme mostrada no esquema a seguir. \n \n \n \nEle percebeu que a soma dos números em cada \nlinha tinha uma propriedade e que, por meio \ndessa propriedade, era possível prever a soma \nde qualquer linha posterior às já construídas. \n \nA partir dessa propriedade, qual será a soma da \n9ª linha da sequência de caixas empilhadas por \nRonaldo? \n \nA) 9          \nB) 45           \nC) 64           \nD) 81           \nE) 285",
    "alternativas": {
      "D": "81",
      "A": "9",
      "B": "45",
      "C": "64"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 179,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0180",
    "numero": 1680,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Para conseguir chegar a um número recorde de \nprodução de ovos de Páscoa, as empresas \nbrasileiras começam a se planejar para esse \nperíodo com um ano de antecedência.  \n \nO gráfico anterior mostra o número de ovos de \nPáscoa produzidos no Brasil no período de \n2005 a 2009.  De acordo com o gráfico, o biênio \nque apresentou maior produção acumulada foi: \n \nA) 2004-2005.        \nB) 2005-2006.        \nC) 2006-2007.        \nD) 2007-2008.        \nE) 2008-2009.",
    "alternativas": {
      "B": "2005-2006.",
      "C": "2006-2007.",
      "D": "2007-2008.",
      "E": "2008-2009."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 180,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0183",
    "numero": 1683,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Desde 2005, o Banco Central não fabrica mais a \nnota de R$ 1,00 e, desde então, só produz di-\nnheiro nesse valor em moedas. Apesar de ser \nmais caro produzir uma moeda, a durabilidade \ndo metal é 30 vezes maior que a do papel. Fa-\nbricar uma moeda de R$ 1,00 custa R$ 0,26, \nenquanto uma nota custa R$ 0,17, entretanto, a \ncédula dura de oito a onze meses.  \nCom R$ 1000,00 destinados a fabricar moedas, \no Banco Central conseguiria fabricar, aproxima-\ndamente, quantas cédulas a mais?  \n \nA) 1667  \nB) 2036  \nC) 3846  \nD) 4300  \nE) 5882",
    "alternativas": {
      "B": "2036",
      "C": "3846",
      "E": "5882",
      "A": "1667"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 183,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0184",
    "numero": 1684,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Existe uma cartilagem entre os ossos que vai \ncrescendo e se calcificando desde a infância até \na idade adulta. No fim da puberdade, os hormô-\nnios sexuais (testosterona e estrógeno) fazem \ncom que essas extremidades ósseas (epífises) \nse fechem e o crescimento seja interrompido. \nAssim, quanto maior a área não calcificada en-\ntre os ossos, mais a criança poderá crescer \nainda. A expectativa é que durante os quatro ou \ncinco anos da puberdade, um garoto ganhe de \n27 a 30 centímetros. \n \nDe acordo com essas informações, um garoto \nque inicia a puberdade com 1,45 m de altura \npoderá chegar ao final dessa fase com uma \naltura:  \n \nA) mínima de 1,458 m \nB) mínima de 1,477 m.  \nC) máxima de 1,480 m.  \nD) máxima de 1,720 m.  \nE) máxima de 1,750 m.",
    "alternativas": {
      "B": "mínima de 1,477 m.",
      "C": "máxima de 1,480 m.",
      "D": "máxima de 1,720 m.",
      "E": "máxima de 1,750 m."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 184,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0185",
    "numero": 1685,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Numa feira de artesanato, uma pessoa constrói \nformas geométricas de aviões, bicicletas, carros \ne outros engenhos com arame inextensível. Em \ncerto momento, ele construiu uma forma tendo \ncomo eixo de apoio outro arame retilíneo e rígi-\ndo, cuja aparência é mostrada na figura seguin-\nte: \n \n \n \nAo girar tal forma em torno do eixo, formou-se a \nimagem de um foguete, que pode ser pensado \ncomo composição, por justaposição, de diversos \nsólidos básicos de revolução.  \n \nSabendo que, a figura, os pontos B, C, E e F \nsão colineares, AB = 4FG, BC = 3FG, EF = \n2FG, e utilizando-se daquela forma de pensar o \nfoguete, a decomposição deste, no sentido da \nponta  para a cauda, é formada pela seguinte \nsequência de sólidos: \nA) pirâmide, cilindro reto, cone reto, cilindro reto.  \nB) cilindro reto, tronco de cone, cilindro reto, \ncone equilátero.  \nC) cone reto, cilindro reto, tronco de cone e \ncilindro equilátero.  \nD) cone equilátero, cilindro reto, pirâmide, cilin-\ndro.  \nE) cone, cilindro equilátero, tronco de pirâmide, \ncilindro.",
    "alternativas": {
      "E": "cone, cilindro equilátero, tronco de pirâmide, cilindro.",
      "B": "cilindro reto, tronco de cone, cilindro reto, cone equilátero.",
      "C": "cone reto, cilindro reto, tronco de cone e cilindro equilátero.",
      "D": "cone equilátero, cilindro reto, pirâmide, cilin- dro."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 185,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0186",
    "numero": 1686,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Nos últimos anos, a corrida de rua cresce no \nBrasil. Nunca se falou tanto no assunto como \nhoje, e a quantidade de adeptos aumenta pro-\ngressivamente, afinal, correr traz inúmeros be-\nnefícios para a saúde física e mental, além de \nser um esporte que não exige um alto investi-\nmento financeiro.  \n \nUm corredor estipulou um plano de treinamento \ndiário, correndo 3 quilômetros no primeiro dia e \naumentando 500 metros por dia, a partir do \nsegundo. Contudo, seu médico cardiologista  \nautorizou essa atividade até que o corredor \natingisse, no máximo, 10 km de corrida em um \nmesmo dia de treino.  \n \nSe o atleta cumprir a recomendação médica e \npraticar o treinamento estipulado corretamente \nem dias consecutivos, pode-se afirmar que esse \nplanejamento de treino só poderá ser executado \nem, exatamente,  \n \nA) 12 dias.  \nB) 13 dias.  \nC) 14 dias.  \nD) 15 dias.  \nE) 16 dias.",
    "alternativas": {
      "E": "16 dias.",
      "A": "12 dias.",
      "C": "14 dias.",
      "D": "15 dias."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 186,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0187",
    "numero": 1687,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Um foguete foi lançado do marco zero de uma \nestação e após alguns segundos atingiu a posi-\nção (6, 6, 7) no espaço, conforme mostra a figu-\nra. As distâncias são medidas em quilômetros. \n \n \nConsiderando que o foguete continuou sua tra-\njetória, mas se deslocou 2 km para frente na \ndireção do eixo-x, 3 km para trás na direção do \neixo-y, e 11 km para frente, na direção do eixo- \nz, então o foguete atingiu a posição:  \n \nA) (17, 3, 9).  \nB) (8, 3, 18).  \nC) (6, 18, 3).  \nD) (4, 9, -4).  \nE) (3, 8, 18).",
    "alternativas": {
      "B": "(8, 3, 18).",
      "D": "(4, 9, -4).",
      "E": "(3, 8, 18).",
      "A": "(17, 3, 9)."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 187,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0188",
    "numero": 1688,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Fontes alternativas \n \nHá um novo impulso para produzir combustível \na partir de gordura animal. Em abril, a High Pla-\nins Bioenergy inaugurou uma biorrefinaria pró-\nxima a uma fábrica de processamento de carne \nsuína em Guymon, Oklahoma. A refinaria con-\nverte a gordura do porco, juntamente com o \nóleo vegetal, em biodiesel. A expectativa da \nfábrica é transformar 14 milhões de quilogramas \nde banha em 112 milhões de litros de biodiesel. \n \nConsidere que haja uma proporção direta entre \na massa de banha transformada e o volume de \nbiodiesel produzido. Para produzir 48 milhões \nde litros de biodiesel, a massa de banha neces-\nsária, em quilogramas, será de, aproximada-\nmente,  \n \nA) 6 milhões.  \nB) 33 milhões.  \nC) 78 milhões.  \nD) 146 milhões.  \nE) 384 milhões.",
    "alternativas": {
      "E": "384 milhões.",
      "A": "6 milhões.",
      "B": "33 milhões.",
      "C": "78 milhões."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 188,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0189",
    "numero": 1689,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "João tem uma loja onde fabrica e vende moe-\ndas de chocolate com diâmetro de 4 cm e preço \nde R$ 1,50 a unidade. Pedro vai a essa loja e, \napós comer várias moedas de chocolate, sugere \nao João que ele faça moedas com 8 cm de diâ-\nmetro e  mesma espessura e cobre R$ 3,00 a \nunidade. Considerando que o preço da moeda \ndepende apenas da quantidade de chocolate, \nJoão: \n  \nA) aceita a proposta de Pedro, pois, se dobra o \ndiâmetro, o preço também deve dobrar.  \nB) rejeita a proposta de Pedro, pois o preço \ncorreto seria R$ 12,00.  \nC) rejeita a proposta de Pedro, pois o preço \ncorreto seria R$ 7,50.  \nD) rejeita a proposta de Pedro, pois o preço \ncorreto seria R$ 6,00.  \nE) rejeita a proposta de Pedro, pois o preço \ncorreto seria R$ 4,50.",
    "alternativas": {
      "B": "rejeita a proposta de Pedro, pois o preço correto seria R$ 12,00.",
      "C": "rejeita a proposta de Pedro, pois o preço correto seria R$ 7,50.",
      "D": "rejeita a proposta de Pedro, pois o preço correto seria R$ 6,00.",
      "A": "aceita a proposta de Pedro, pois, se dobra o diâmetro, o preço também deve dobrar."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 189,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0190",
    "numero": 1690,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "O gráfico expõe alguns números da gripe A-H1N1. Entre as categorias que estão em processo de imuni-\nzação, uma já está completamente imunizada, a dos trabalhadores da saúde. \n \n \n \nDe acordo com o gráfico, entre as demais categorias, a que está mais exposta ao vírus da gripe A-H1N1 \né a categoria de:  \n \nA) indígenas.  \nB) gestantes.  \nC) doentes crônicos.  \nD) adultos entre 20 e 29 anos.  \nE) crianças de 6 meses a 2 anos.",
    "alternativas": {
      "E": "crianças de 6 meses a 2 anos.",
      "B": "gestantes.",
      "C": "doentes crônicos.",
      "D": "adultos entre 20 e 29 anos."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 190,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0191",
    "numero": 1691,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Uma torneira gotejando diariamente é respon-\nsável por grandes desperdícios de água. Obser-\nve o gráfico que indica o desperdício de uma \ntorneira: \n \n \n \nSe y representa o desperdício de água, em li-\ntros, e x representa o tempo, em dias, a relação \nentre x e y é: \n  \nA) y = 2x \n \nB) y =  \n1\n2x \n \nC) y = 60x \n \n \nD) y = 60 + x \n \n \nE) 80x + 50",
    "alternativas": {
      "C": "y = 60x",
      "D": "y = 60 + x",
      "E": "80x + 50",
      "A": "y = 2x"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 191,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0192",
    "numero": 1692,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "O hábito de comer um prato de folhas todo dia \nfaz proezas para o corpo. Uma das formas de \nvariar o sabor das saladas é experimentar dife-\nrentes molhos. Um molho de iogurte com mos-\ntarda contém 2 colheres de sopa de iogurte \ndesnatado, 1 colher de sopa de mostarda, 4 \ncolheres de sopa de água, 2 colheres de sopa \nde azeite.  \n \nConsiderando que uma colher de sopa equivale \na aproximadamente 15 mL, qual é o número \nmáximo de doses desse molho que se faz utili-\nzando 1,5 L de azeite e mantendo a proporcio-\nnalidade das quantidades dos demais ingredien-\ntes?  \n \nA) 5  \nB) 20  \nC) 50  \nD) 200  \nE) 500",
    "alternativas": {
      "B": "20",
      "C": "50",
      "E": "500",
      "A": "5"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 192,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0193",
    "numero": 1693,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "No dia 12 de janeiro de 2010, o governo da \nVenezuela adotou um plano de racionamento de \nenergia que previa cortes no fornecimento em \ntodo o país. O ministro da energia afirmou que \numa das formas mais eficazes de se economi-\nzar energia nos domicílios seria o uso de lâm-\npadas que consomem 20% menos da energia \nconsumida por lâmpadas normais. \nEm uma residência, o consumo mensal de \nenergia proveniente do uso de lâmpadas co-\nmuns é de 63 kWh. Se todas as lâmpadas des-\nsa residência forem trocadas pelas lâmpadas \neconômicas, esse consumo passará a ser de, \naproximadamente,  \n \nA) 9 kWh.  \nB) 11 kWh.  \nC) 22 kWh.  \nD) 35 kWh.  \nE) 50 kWh.",
    "alternativas": {
      "B": "11 kWh.",
      "C": "22 kWh.",
      "E": "50 kWh.",
      "A": "9 kWh."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 193,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0194",
    "numero": 1694,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Em abril de 2009, o observatório espacial ame-\nricano Swift captou um feixe de raios gama pro-\nveniente de uma explosão no espaço. Cientistas \nitalianos e ingleses apresentaram conclusões de \nque as luzes captadas provêm do colapso de \numa estrela ocorrido há 13 bilhões de anos, \napenas 630 milhões de anos após o Big Bang, \nexpansão súbita que originou o Universo. Bati-\nzada de GRB 090423, a estrela é o objeto ce-\nleste mais antigo já observado pelo homem. \n \nSuponha uma escala de 0 h a 24 h e considere \nque o Big Bang ocorreu exatamente à 0 h. Des-\nse modo, a explosão da estrela GRB 090423 \nteria ocorrido à(s): \n  \nA) 1,10 h.  \nB) 1,16 h.  \nC) 1,22 h.  \nD) 1,84 h.  \nE) 2,01 h.",
    "alternativas": {
      "B": "1,16 h.",
      "C": "1,22 h.",
      "D": "1,84 h.",
      "A": "1,10 h."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 194,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0195",
    "numero": 1695,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Em uma reserva florestal existem 263 espécies \nde peixes, 122 espécies de mamíferos, 93 es-\npécies de répteis, 1132 espécies de borboletas \ne 656 espécies de aves. Se uma espécie animal \nfor capturada ao acaso, qual a probabilidade de \nser uma borboleta?  \n \nA) 63,31%  \nB) 60,18%  \nC) 56,52%  \nD) 49,96%  \nE) 43,27%",
    "alternativas": {
      "B": "60,18%",
      "C": "56,52%",
      "D": "49,96%",
      "E": "43,27%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 195,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0196",
    "numero": 1696,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "As Olimpíadas de 2016 serão realizadas na \ncidade do Rio de Janeiro. Uma das modalidades \nque trazem esperanças de medalhas para o \nBrasil é a natação. Aliás, a piscina olímpica \nmerece uma atenção especial devido as suas \ndimensões. Piscinas olímpicas têm 50 metros \nde comprimento por 25 metros de largura.  \nSe a piscina olímpica fosse representada em \numa escala de 1:100, ela ficaria com as medi-\ndas de: \n  \nA) 0,5 centímetro de comprimento e 0,25 centí-\nmetro de largura.  \nB) 5 centímetros de comprimento e 2,5 centíme-\ntros de largura.  \nC) 50 centímetros de comprimento e 25 centí-\nmetros de largura.  \nD) 500 centímetros de comprimento e 250 cen-\ntímetros de largura.  \nE) 200 centímetros de comprimento e 400 cen-\ntímetros de largura.",
    "alternativas": {
      "D": "500 centímetros de comprimento e 250 cen- tímetros de largura.",
      "E": "200 centímetros de comprimento e 400 cen- tímetros de largura.",
      "A": "0,5 centímetro de comprimento e 0,25 centí- metro de largura.",
      "C": "50 centímetros de comprimento e 25 centí- metros de largura."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 196,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0197",
    "numero": 1697,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Grandes times nacionais e internacionais utili-\nzam dados estatísticos para a definição do time \nque sairá jogando numa partida. Por exemplo, \nnos últimos treinos, dos chutes a gol feito pelo \njogador I, ele converteu 45 chutes em gol. En-\nquanto isso, o jogador II acertou 50 gols. Quem \ndeve ser selecionado para estar no time no pró-\nximo jogo, já que os dois jogam na mesma posi-\nção?  \n \nA decisão parece simples, porém deve-se levar \nem conta quantos chutes a gol cada um teve \noportunidade de executar. Se o jogador I chutou \n60 bolas a gol e o jogador II chutou 75, quem \ndeveria ser escolhido?  \n \nA) O jogador I, porque acertou 3/4 dos chutes, \nenquanto o jogador II acertou 2/3 dos chutes.  \nB) O jogador I, porque acertou 4/3 dos chutes, \nenquanto o jogador II acertou 2/3 dos chutes.  \nC) O jogador I, porque acertou 3/4 dos chutes, \nenquanto o jogador II acertou 3/2 dos chutes.  \nD) O jogador I, porque acertou 12/25 dos chu-\ntes, enquanto o jogador II acertou 2/3 dos chu-\ntes.  \nE) O jogador I, porque acertou 9/25 dos chutes, \nenquanto o jogador II acertou 2/5 dos chutes.",
    "alternativas": {
      "A": "O jogador I, porque acertou 3/4 dos chutes, enquanto o jogador II acertou 2/3 dos chutes.",
      "B": "O jogador I, porque acertou 4/3 dos chutes, enquanto o jogador II acertou 2/3 dos chutes.",
      "D": "O jogador I, porque acertou 12/25 dos chu- tes, enquanto o jogador II acertou 2/3 dos chu- tes.",
      "E": "O jogador I, porque acertou 9/25 dos chutes, enquanto o jogador II acertou 2/5 dos chutes."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 197,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0198",
    "numero": 1698,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Uma empresa de refrigerantes, que funciona \nsem interrupções, produz um volume constante \nde 1800000 cm3 de líquido por dia. A máquina \nde encher garrafas apresentou um defeito du-\nrante 24 horas. O inspetor de produção perce-\nbeu que o líquido chegou apenas à altura de \n12cm dos 20cm previstos em cada garrafa.  \n \nA parte inferior da garrafa em que foi depositado \no líquido tem forma cilíndrica com raio da base \nde 3 cm. Por questões de higiene, o líquido já \nengarrafado não será reutilizado. \nUtilizando π ≅3 , no período em que a máquina \napresentou defeito, aproximadamente quantas \ngarrafas foram utilizadas?  \n \nA) 555  \nB) 5555  \nC) 1333  \nD) 13333  \nE) 133333",
    "alternativas": {
      "A": "555",
      "B": "5555",
      "C": "1333",
      "E": "133333"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 198,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0199",
    "numero": 1699,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Se pudéssemos reunir em esferas toda a água \ndo planeta, os diâmetros delas seriam: \n \n \n \nA razão entre o volume da esfera que corres-\nponde à água doce superficial e o volume da \nesfera que corresponde à água doce do planeta \né: \n  \nA) 1/343  \nB) 1/49  \nC) 1/7  \nD) 29/136  \nE) 136/203",
    "alternativas": {
      "C": "1/7",
      "D": "29/136",
      "A": "1/343",
      "B": "1/49"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 199,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0200",
    "numero": 1700,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "O IGP-M é um índice da Fundação Getúlio Var-\ngas, obtido por meio da variação dos preços de \nalguns setores da economia, do dia vinte e um \ndo mês anterior ao dia vinte do mês de referên-\ncia. Ele é calculado a partir do Índice de Preços \npor Atacado (IPA-M), que tem peso de 60% do \níndice, do Índice de Preços ao Consumidor \n(IPC-M), que tem peso de 30%, e do Índice \nNacional de Custo de Construção (INCC), re-\npresentando 10%.  \nAtualmente, o IGP-M é o índice para a correção \nde contratos de aluguel e o indexador de algu-\nmas tarifas, como energia elétrica. \n \n \n \n \n \n \n \nA partir das informações, é possível determinar \no maior IGP-M mensal desse primeiro trimestre, \ncujo valor é igual a: \n  \nA) 7,03%.  \nB) 3,00%.  \nC) 2,65%.  \nD) 1,15%.  \nE) 0,66%.",
    "alternativas": {
      "C": "2,65%.",
      "D": "1,15%.",
      "E": "0,66%.",
      "B": "3,00%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 200,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0201",
    "numero": 1701,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "As sacolas plásticas sujam florestas, rios e oce-\nanos e quase sempre acabam matando por \nasfixia peixes, baleias e outros animais aquáti-\ncos. No Brasil, em 2007, foram consumidas 18 \nbilhões de sacolas plásticas. Os supermercados \nbrasileiros se preparam para acabar com as \nsacolas plásticas até 2016. Observe o gráfico a \nseguir, em que se considera a origem como o \nano de 2007. \nDe acordo com as informações, quantos bilhões \nde sacolas plásticas serão consumidos em \n2011?  \n \nA) 4,0  \nB) 6,5  \nC) 7,0  \nD) 8,0  \nE) 10,0",
    "alternativas": {
      "C": "7,0",
      "D": "8,0",
      "E": "10,0",
      "A": "4,0"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 201,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0202",
    "numero": 1702,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Os estilos musicais preferidos pelos jovens bra-\nsileiros são o samba, o rock e a MPB. O quadro \na seguir registra o resultado de uma pesquisa \nrelativa à preferência musical de um grupo de \n1000 alunos de uma escola. Alguns alunos dis-\nseram não ter preferência por nenhum desses \ntrês estilos. \n \n \n \nSe for selecionado ao acaso um estudante no \ngrupo pesquisado, qual é a probabilidade de ele \npreferir somente MPB?  \n \nA) 2%  \nB) 5%  \nC) 6%  \nD) 11%  \nE) 20%",
    "alternativas": {
      "E": "20%",
      "A": "2%",
      "B": "5%",
      "D": "11%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 202,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0203",
    "numero": 1703,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Em uma corrida de regularidade, a equipe cam-\npeã é aquela em que o tempo dos participantes \nmais se aproxima do tempo fornecido pelos \norganizadores em cada etapa. Um campeonato \nfoi organizado em 5 etapas, e o tempo médio de \nprova indicado pelos organizadores foi de 45 \nminutos por prova. No quadro, estão represen-\ntados os dados estatísticos das cinco equipes \nmais bem classificadas. \n \nDados estatísticos das equipes mais bem \nclassificadas (em minutos) \n \n \nUtilizando os dados estatísticos do quadro, a \ncampeã foi a equipe: \n \nA) I.  \nB) II.  \nC) III.  \nD) IV.  \nE) V.",
    "alternativas": {
      "A": "I.",
      "B": "II.",
      "C": "III.",
      "E": "V."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 203,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0204",
    "numero": 1704,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "O administrador de uma cidade, implantando \numa política de reutilização de materiais descar-\ntados, aproveitou milhares de tambores cilíndri-\ncos dispensados por empresas da região e \nmontou kits com seis tambores para o abaste-\ncimento de água em casas de famílias de baixa \nrenda, conforme a figura seguinte. Além disso, \ncada família envolvida com o programa irá pa-\ngar somente R$ 2,50 por metro cúbico utilizado. \n \n \n \nUma família que utilizar 12 vezes a capacidade \ntotal do kit em um mês pagará a quantia de: \n(Considere π ≅3) \n \nA) R$ 86,40.  \nB) R$ 21,60.  \nC) R$ 8,64.  \nD) R$ 7,20. \nE) R$ 1,80.",
    "alternativas": {
      "C": "R$ 8,64.",
      "D": "R$ 7,20.",
      "A": "R$ 86,40.",
      "B": "R$ 21,60."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 204,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0205",
    "numero": 1705,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "O Pantanal é um dos mais valiosos patrimônios \nnaturais do Brasil. É a maior área úmida conti-\nnental do planeta - com aproximadamente 210 \nmil2 km, sendo 140 mil2 km em território brasilei-\nro, cobrindo parte dos estados de Mato Grosso \ne Mato Grosso do Sul. As chuvas fortes são \ncomuns nessa região. O equilíbrio desse ecos-\nsistema depende, basicamente, do fluxo de \nentrada e saída de enchentes. As cheias che-\ngam a cobrir até 2/3 da área pantaneira. \n \nDurante o período chuvoso, a área alagada \npelas enchentes pode chegar a um valor apro-\nximado de: \nA) 91,3 mil km2 \nB) 93,3 mil km2 \nC) 140 mil km2 \nD) 152,1 mil km2 \nE) 233,3 mil km2",
    "alternativas": {
      "E": "233,3 mil km2",
      "B": "93,3 mil km2",
      "C": "140 mil km2",
      "D": "152,1 mil km2"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 205,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0206",
    "numero": 1706,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Um laticínio possui dois reservatórios de leite. \nCada reservatório é abastecido por uma torneira \nacoplada a um tanque resfriado. O volume, em \nlitros, desses reservatórios depende da quanti-\ndade inicial de leite no reservatório e do tempo t, \nem horas, em que as duas torneiras ficam aber-\ntas. Os volumes são dados pelas funções: \n \nV1(t) = 250t3 – 100t + 3000 e \nV2(t) = 150t3 – 69t + 3000 \n \nDepois de aberta cada torneira, o volume de \nleite de um reservatório é igual ao do outro no \ninstante t = 0 e, também, no tempo t igual a:  \n \nA) 1,3 h.  \nB) 1,69 h.  \nC) 10,0 h. \nD) 13,0 h.  \nE) 16,9 h.",
    "alternativas": {
      "C": "10,0 h.",
      "D": "13,0 h.",
      "E": "16,9 h.",
      "A": "1,3 h."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 206,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0207",
    "numero": 1707,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Em fevereiro, o governo da Cidade do México, \nmetrópole com uma das maiores frotas de au-\ntomóveis do mundo, passou a oferecer à popu-\nlação bicicletas como opção de transporte. Por \numa anuidade de 24 dólares, os usuários têm \ndireito a 30 minutos de uso livre por dia. O ciclis-\nta pode retirar em uma estação e devolver em \nqualquer outra e, se quiser estender a pedalada, \npaga 3 dólares por hora extra. \n \nA expressão que relaciona o valor f pago pela \nutilização da bicicleta por um ano, quando se \nutilizam x horas extras nesse período é: \n  \nA) f(x) = 3x \nB) f(x) = 24  \nC) f(x)  = 27  \nD) f(x) = 3x + 24 \nE) f(x) = 24x + 3",
    "alternativas": {
      "A": "f(x) = 3x",
      "B": "f(x) = 24",
      "D": "f(x) = 3x + 24",
      "E": "f(x) = 24x + 3"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 207,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0208",
    "numero": 1708,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Para verificar e analisar o grau de eficiência de \num teste que poderia ajudar no retrocesso de \numa doença numa comunidade, uma equipe de \nbiólogos aplicou-o em um grupo de 500 ratos, \npara detectar a presença dessa doença. Porém, \no teste não é totalmente eficaz podendo existir \nratos saudáveis com resultado positivo e ratos \ndoentes com resultado negativo. Sabe-se, ain-\nda, que 100 ratos possuem a doença, 20 ratos \nsão saudáveis com resultado positivo e 40 ratos \nsão doentes com resultado negativo.  \n \nUm rato foi escolhido ao acaso, e verificou-se \nque o seu resultado deu negativo. A probabili-\ndade de esse rato ser saudável: \n \nA) 1/5 \nB) 4/5 \nC) 19/21 \nD) 19/25 \nE) 21/25",
    "alternativas": {
      "B": "4/5",
      "C": "19/21",
      "E": "21/25",
      "A": "1/5"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 208,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0209",
    "numero": 1709,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Devido aos fortes ventos, uma empresa explo-\nradora de petróleo resolveu reforçar a seguran-\nça de suas plataformas marítimas, colocando \ncabos de aço para melhor afixar a torre central.  \n \nConsidere que os cabos ficarão perfeitamente \nesticados e terão uma extremidade no ponto \nmédio das arestas laterais da torre central (pi-\nrâmide quadrangular regular) e a outra no vérti-\nce da base da plataforma (que é um quadrado \nde lados paralelos aos lados da base da torre \ncentral e centro coincidente com o centro da \nbase da pirâmide), como sugere a ilustração. \n \n \n \nSe a altura e a aresta da base da torre central \nmedem, respectivamente, 24 m e 6√2 e o lado \nda base da plataforma mede 19√2, então a \nmedida, em metros, de cada cabo será igual a: \n \nA) √288 \nB) √313 \nC) √328 \nD) √400 \nE) √505",
    "alternativas": {
      "B": "√313",
      "C": "√328",
      "D": "√400",
      "A": "√288"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 209,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0210",
    "numero": 1710,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Um experimento foi conduzido com o objetivo \nde avaliar o poder germinativo de duas culturas \nde cebola, conforme a tabela. \nGerminação de sementes de duas  \nculturas de cebola \n \n \n \nDesejando-se fazer uma avaliação do poder \ngerminativo de uma das culturas de cebola, uma \namostra foi retirada ao acaso. Sabendo-se que \na amostra escolhida germinou, a probabilidade \nde essa amostra pertencer à Cultura A é de:  \n \nA) 8/27  \nB) 19/27  \nC) 381/773  \nD) 392/773  \nE) 392/800",
    "alternativas": {
      "E": "392/800",
      "B": "19/27",
      "C": "381/773",
      "D": "392/773"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 210,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0211",
    "numero": 1711,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Com o intuito de tentar prever a data e o valor \ndo reajuste do próximo salário mínimo, José \nprimeiramente observou o quadro dos reajustes \ndo salário mínimo de abril de 2000 até fevereiro \nde 2009, mostrada a seguir.  \n \nEle procedeu da seguinte maneira: computou o \nmenor e o maior intervalo entre dois reajustes e \ncomputou a média dos valores encontrados, e \nusou este resultado para predizer a data do \npróximo aumento. Em seguida, determinou o \nmenor e o maior reajuste percentual, ocorrido, \ntomou a média e usou este resultado para de-\nterminar o valor aproximado do próximo salário. \n \n \n \nDe acordo com os cálculos de José, a data do \nnovo reajuste do salário mínimo e o novo valor \naproximado do mesmo seriam, respectivamen-\nte, \nA) fevereiro de 2010 e R$ 530,89. \nB) fevereiro de 2010 e R$ 500,00. \nC) fevereiro de 2010 e R$ 527,27. \nD) janeiro de 2010 e R$ 530,89. \nE) janeiro de 2010 e R$ 500,00.",
    "alternativas": {
      "D": "janeiro de 2010 e R$ 530,89.",
      "E": "janeiro de 2010 e R$ 500,00.",
      "A": "fevereiro de 2010 e R$ 530,89.",
      "C": "fevereiro de 2010 e R$ 527,27."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 211,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0212",
    "numero": 1712,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "O trabalho em empresas de exige dos profissio-\nnais conhecimentos de diferentes áreas. Na \nsemana passada, todos os funcionários de uma \ndessas empresas estavam envolvidos na tarefa \nde determinar a quantidade de estrelas que \nseriam utilizadas na confecção de um painel de \nNatal.  \n \nUm dos funcionários apresentou um esboço das \nprimeiras cinco linhas do painel, que terá, no \ntotal, 150 linhas. \n \n \n \nApós avaliar o esboço, cada um dos funcioná-\nrios esboçou sua resposta:  \n \nFuncionário I: aproximadamente 200 estrelas.  \nFuncionário II: aproximadamente 6000 estrelas.  \nFuncionário III: aproximadamente 12000 estrelas.  \nFuncionário IV: aproximadamente 22500 estrelas.  \nFuncionário V: aproximadamente 22800 estrelas. \n \nQual funcionário apresentou um resultado mais \npróximo da quantidade de estrelas necessária?  \n \nA) I \nB) II  \nC) III  \nD) IV  \nE) V",
    "alternativas": {
      "B": "II",
      "C": "III",
      "E": "V",
      "A": "I"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 212,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0213",
    "numero": 1713,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Um arquiteto está fazendo um projeto de ilumi-\nnação de ambiente e necessita saber a altura \nque deverá instalar a luminária ilustrada na figu-\nra: \nSabendo-se que a luminária deverá iluminar \numa área circular de 28,26m2, considerando \nπ ≅3 , a altura h será igual a: \n  \nA) 3 m.  \nB) 4 m.  \nC) 5 m.  \nD) 9 m.  \nE) 16 m.",
    "alternativas": {
      "E": "16 m.",
      "A": "3 m.",
      "B": "4 m.",
      "C": "5 m."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 213,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0214",
    "numero": 1714,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Uma bióloga conduziu uma série de experimen-\ntos demonstrando que a cana-de-açúcar manti-\nda em um ambiente com o dobro da concentra-\nção atual de CO2 realiza 30% mais de fotossín-\ntese e produz 30% mais de açúcar do que a que \ncresce sob a concentração normal de CO2. Das \ncâmaras que mantinham esse ar rico em gás \ncarbônico, saíram plantas também mais altas e \nmais encorpadas, com 40% mais de biomassa.  \n \nOs resultados indicam que se pode obter a \nmesma produtividade de cana numa menor área \ncultivada. Nas condições apresentadas de utili-\nzar o dobro da concentração de CO2 no cultivo \npara dobrar a produção da biomassa da cana-\nde-açúcar, a porcentagem da área cultivada \nhoje deveria ser, aproximadamente,  \n \nA) 80%.  \nB) 100%.  \nC) 140%.  \nD) 160%.  \nE) 200%.",
    "alternativas": {
      "D": "160%.",
      "A": "80%.",
      "B": "100%.",
      "C": "140%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 214,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0215",
    "numero": 1715,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Algumas pesquisas estão sendo desenvolvidas \npara se obter arroz e feijão com maiores teores \nde ferro e zinco e tolerantes à seca. Em média, \npara cada 100 g de arroz cozido, o teor de ferro \né de 1,5 mg e o de zinco é de 2,0 mg. Para 100 \ng de feijão, é de 7 mg o teor de ferro e de 3 mg \no de zinco. Sabe-se que as necessidades diá-\nrias dos dois micronutrientes para uma pessoa \nadulta é de aproximadamente 12,25 mg de ferro \ne 10 mg de zinco. \n \nConsidere que uma pessoa adulta deseja satis-\nfazer suas necessidades diárias de ferro e zinco  \ningerindo apenas arroz e feijão. Suponha que \nseu organismo absorva completamente todos os  \nmicronutrientes oriundos desses alimentos.  \n \nNa situação descrita, que quantidade a pessoa \ndeveria comer diariamente de arroz e feijão, \nrespectivamente?  \n \nA) 58 g e 456 g  \nB) 200 g e 200 g  \nC) 350 g e 100 g  \nD) 375 g e 500 g  \nE) 400 g e 89 g",
    "alternativas": {
      "C": "350 g e 100 g",
      "D": "375 g e 500 g",
      "E": "400 g e 89 g",
      "B": "200 g e 200 g"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 215,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];